import dedent from 'ts-dedent'
import { MILES_TO_M } from '../const'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Length extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.length',
        group: 'Spatial Operations',
        title: 'ST Length',
        description: `
      This component calculates the length
      of LineStrings in the input table.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source lines table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'units',
          type: WorkflowComponentParamType.Selection,
          title: 'Units',
          options: ['Meters', 'Miles'],
          default: 'Meters'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const convert = params.units === 'Meters' ? '' : ` / ${MILES_TO_M}`
    switch (connection.type) {
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const lengthColumn = `${params.geo}_length`
        return dedent`SELECT
                  (
                    SDO_GEOM.SDO_LENGTH(${geoColumn}, 0.005)
                  ) ${convert}
                  AS ${lengthColumn}, t.*
                FROM ${connection.quoteName(params.source as string)} t`
      }
      case Provider.Redshift:
      case Provider.Postgres:
        return dedent`SELECT
                  (
                    ST_LENGTH(${params.geo}::geography)
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  (
                    ST_LENGTH(${connection.processInputGeogColumn(params.geo as string)})
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source as string)}`
      default:
        return dedent`SELECT
                  (
                    ST_LENGTH(${connection.processInputGeogColumn(params.geo as string)})
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_length`,
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { Length }
